import { useSelector, shallowEqual } from 'react-redux';
import { selectedAddress } from 'state/selected-address/selected-address-slice';
import { useMeterType } from './useMeterType';
import { useHasInitialState } from 'components/direct-sales/energy-needs/hooks/useHasInitialState';

export const useMeterValidation = () => {
  const address = useSelector(selectedAddress, shallowEqual);
  const { hasElectricityMeter, hasGasMeter } = useMeterType();
  const { fuel: hasFuelInitialState } = useHasInitialState();
  const hasAddress = !!address;
  const hasAnyMeterValidationRequired =
    hasFuelInitialState && hasAddress && (!hasElectricityMeter || !hasGasMeter);

  return { hasAnyMeterValidationRequired };
};
